class UtilizationGraphManager {
  constructor(data, filterType = '') {
    this.filterType = filterType;

    this.data = Object.fromEntries(
      Object.entries(data.result)
        .filter(([key, _]) => !!key)
    );
    const isCustomerCountObject = data.customer_count && typeof data.customer_count === 'object' && !Array.isArray(data.customer_count);
    this.customerCount = isCustomerCountObject
      ? Object.fromEntries(
          Object.entries(data.customer_count)
            .filter(([key, value]) => !!value)
            .sort(([key1, value1], [key2, value2]) => {
              if (String(key1).toLowerCase() < String(key2).toLowerCase()) return -1;
              if (String(key1).toLowerCase() > String(key2).toLowerCase()) return 1;
              return 0;
            })
            .slice(0, 50)
        )
      : null;
    this.totalCustomerCount = !isCustomerCountObject ? data.customer_count : null;
    this.type = data.type
    this.total = this.getTotal(this.data);
    this.bardata = this.getBarData(this.data, this.total, this.customerCount);
    
    const labelData = isCustomerCountObject ? this.customerCount : this.data;
    this.barlabels = this.getBarLables(labelData);

    if (['department', 'location'].includes(this.filterType)) {
      const combined = this.barlabels.map((label, i) => ({
        label,
        value: this.bardata[i],
      }));
      combined.sort((a, b) => {
        const valA = typeof a.value === 'object' ? a.value.v : a.value;
        const valB = typeof b.value === 'object' ? b.value.v : b.value;
        return valB - valA;
      });

      this.barlabels = combined.map((item) => item.label);
      this.bardata = combined.map((item) => item.value);
    } else {
      const combined = Object.keys(labelData).map((label) => ({
        label,
        value: this.bardata[this.barlabels.indexOf(label)],
      }));

      this.barlabels = combined.map((item) => item.label);
      this.bardata = combined.map((item) => item.value);
    }

    this.maxUtilizationValue = null;
    this.barBgColors = this.getBarBgColors.apply(this, [this.customerCount || this.data]);
    this.bardata = this.bardata;
  }

  apiResponse = () => {
    return this.data;
  };

  getTotal(data) {
    if (data) {
      if(this.type === 'spending_account'){
        let total = Object.values(data).reduce((total, num) => total + num, 0);
       return total / 1000
      }
      return Object.values(data).reduce((total, num) => total + num, 0);
    }
  }

  getBarData(data, total, categoryWiseTotalCount = null) {
    let total_sum = 0,
      res = [];
    if (data) {
      if (this.type === "spending_account") {
        res = Object.values(data).map((value, index) => {
          let val = Math.round(value / 1000);
          return val;
        });
      } else if (categoryWiseTotalCount && typeof categoryWiseTotalCount === 'object') {
        res = Object.keys(categoryWiseTotalCount).map((key, index) => {
          if (!data[key] || !categoryWiseTotalCount[key]) {
            return { v: 0, t: 0 };
          }
          let percentage = (data[key] / categoryWiseTotalCount[key]) * 100;
          // Apply power scale to handle large vs small value disparity
          const scaledVal = Math.sqrt(percentage / 100) * 100;
          return { v: scaledVal, t: Math.round(percentage * 100) / 100 };
        });
      } else {
        res = Object.values(data).map((value, index) => {
          let percentage = (value / total) * 100;
          // Apply power scale to handle large vs small value disparity
          const scaledVal = Math.sqrt(percentage / 100) * 100;
          return { v: scaledVal, t: Math.round(percentage * 100) / 100 };
        });
      }
    }
    return res;
  }

  getBarLables(data) {
    if (data) {
      return Object.keys(data);
    }
  }

  getBarBgColors(data) {
    if (data) {
      const values = Object.values(data).map(v => typeof v === 'object' ? v.v : v);
      let bgcolors = new Array(values.length).fill('#5A8BED');
      const maxInd = this.getMaxIndex(values);
      this.maxUtilizationValue = values[maxInd];
      return bgcolors;
    }
  }

  getMaxIndex(arr) {
    let maxInd = 0;
    for (let [ind, ele] of arr.entries()) {
      if (ele > arr[maxInd]) maxInd = ind;
    }
    return maxInd;
  }
}

export default UtilizationGraphManager;
